module.exports = __webpack_public_path__ + "static/media/share-game.8c7c30d3.png";